import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { guestGuard } from './core/guards/guest.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./layout/public-layout/public-layout.component').then((m) => m.PublicLayoutComponent),
    children: [
      {
        path: '',
        loadComponent: () => import('./features/website/home/home.component').then((m) => m.HomeComponent),
        title: 'Anubhuti Institute | Build Your Skills, Shape Your Future',
      },
      {
        path: 'franchise/register',
        loadComponent: () =>
          import('./features/website/franchise-register/franchise-register.component').then(
            (m) => m.FranchiseRegisterComponent,
          ),
        title: 'Register Franchise | Anubhuti Institute',
      },
    ],
  },
  {
    // Listed before the register/login block below: Angular's router tries routes in
    // array order and, for a parent route with no leftover URL segments (e.g. exactly
    // `/student`), a path match succeeds even if no child matches — it doesn't backtrack
    // to try a later sibling. Putting the more specific `/student` (dashboard) tree first
    // ensures `/student` itself resolves here; `/student/register` and `/student/login`
    // still fall through correctly since neither matches any child path in this block.
    path: 'student',
    loadComponent: () =>
      import('./layout/student-layout/student-layout.component').then((m) => m.StudentLayoutComponent),
    canActivate: [authGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./features/student/dashboard/dashboard.component').then((m) => m.DashboardComponent),
        title: 'Student Dashboard',
      },
      {
        path: 'courses',
        loadComponent: () =>
          import('./features/student/courses/course-list/course-list.component').then(
            (m) => m.CourseListComponent,
          ),
        title: 'Courses',
      },
      {
        path: 'courses/:id',
        loadComponent: () =>
          import('./features/student/courses/course-detail/course-detail.component').then(
            (m) => m.CourseDetailComponent,
          ),
        title: 'Course Details',
      },
      {
        path: 'my-course',
        loadComponent: () =>
          import('./features/student/my-course/my-course.component').then((m) => m.MyCourseComponent),
        title: 'My Course',
      },
      {
        path: 'profile',
        loadComponent: () =>
          import('./features/student/profile/profile.component').then((m) => m.ProfileComponent),
        title: 'Profile',
      },
    ],
  },
  {
    path: 'student',
    loadComponent: () =>
      import('./layout/auth-layout/auth-layout.component').then((m) => m.AuthLayoutComponent),
    canActivate: [guestGuard],
    children: [
      {
        path: 'register',
        loadComponent: () =>
          import('./features/student/registration/registration.component').then(
            (m) => m.RegistrationComponent,
          ),
        title: 'Create Student Account',
      },
      {
        // Login and registration share one mobile + OTP flow: after verifying, an
        // existing student goes to the dashboard and a new one sees the registration form.
        path: 'login',
        loadComponent: () =>
          import('./features/student/registration/registration.component').then(
            (m) => m.RegistrationComponent,
          ),
        data: { mode: 'login' },
        title: 'Student Login',
      },
    ],
  },
  {
    path: '**',
    loadComponent: () => import('./features/not-found/not-found.component').then((m) => m.NotFoundComponent),
    title: 'Page Not Found',
  },
];
